const MAX_TRANSPARENCY = 1;
const MIN_TRANSPARENCY = 0;

const generateId = (layerName, opacityPropertyName) => {
  return layerName + '@@@' + opacityPropertyName;
};

// #region Actions
const actions = {
  async removeLayerSettings({commit}, {layerId}) {
    commit('removeLayerSettings', {layerId});
  },
  async saveLayerSettings(
    {commit},
    {layerId, opacityPropertyName, opacity}) {
    commit('saveLayerSettings', {layerId, opacityPropertyName, opacity});
  },
  async setLayerTransparency({commit}, {layerId, opacityPropertyName, transparency}) {
    commit('setLayerTransparency', {layerId, opacityPropertyName, transparency});
  },
};
// #endregion

// #region Getters
const getters = {
  getLayerState: (state) => (layerId, opacityPropertyName = 'all') => {
    const id = generateId(layerId, opacityPropertyName);
    return state.layersSettings[id];
  },
  layersSettingsKeys: (state) => {
    return Object.keys(state.layersSettings);
  },
};
// #endregion

// #region Mutations
const mutations = {
  removeLayerSettings(state, {layerId}) {
    const layerIdKeys = Object.keys(state.layersSettings);
    for (const key of layerIdKeys) {
      if (key.startsWith(layerId)) {
        delete state.layersSettings[key];
      }
    }
  },
  saveLayerSettings(state, {layerId, opacityPropertyName, opacity}) {
    const id = generateId(layerId, opacityPropertyName);
    const oldLayerSettings = state.layersSettings[id];
    if (!oldLayerSettings) {
      state.layersSettings[id] = resetLayerSettings({layerId, opacityPropertyName, opacity});
    } else {
      const newOriginalState = {
        opacity,
      };
      state.layersSettings[id] = {...oldLayerSettings, originalState: newOriginalState};
    }
  },
  setLayerTransparency(state, {layerId, opacityPropertyName, transparency}) {
    if (transparency != null &&
        transparency >= MIN_TRANSPARENCY &&
        transparency <= MAX_TRANSPARENCY) {
      const id = generateId(layerId, opacityPropertyName);
      const savedLayerSettings = state.layersSettings[id];
      const newLayerSettings = {layerId, opacityPropertyName,
        transparency, originalState: null};
      if (!!savedLayerSettings?.originalState) {
        newLayerSettings.originalState = {...savedLayerSettings.originalState};
      }
      state.layersSettings[id] = newLayerSettings;
    }
  },
};
// #endregion
const resetLayerSettings = ({layerId, opacityPropertyName, opacity}) => {
  return {
    layerId,
    opacityPropertyName,
    transparency: 0,
    originalState: {
      opacity,
    },
  };
};
// #region State
const state = () => {
  return {
    layersSettings: {},
  };
};
// #endregion


// #region Etc
const namespaced = true;
const modules = []; // Submodules
// #endregion


export default {
  actions,
  getters,
  modules,
  mutations,
  namespaced,
  state,
};
